// react-native-web maps TouchableNativeFeedback → UnimplementedView (renders its
// child in a plain View with NO press handling), so every `<TouchableNativeFeedback
// onPress>` in the app is DEAD on web (e.g. the delivery cards' "View Details").
// Replace it with a TouchableOpacity-backed component that actually fires onPress.
// Wired via NormalModuleReplacementPlugin in webpack.web.config.js (RNW exports it
// as a read-only getter, so it can't be patched at runtime).
const React = require("react");
const TouchableOpacity = require("react-native-web/dist/exports/TouchableOpacity").default;

function TouchableNativeFeedback(props) {
  // strip Android-only props; pass everything else (onPress, disabled, testID…) through.
  const { background, useForeground, children, ...rest } = props || {};
  return React.createElement(TouchableOpacity, Object.assign({ activeOpacity: 0.7 }, rest), children);
}

// Android-only statics components call (e.g. background={TNF.Ripple(...)}).
TouchableNativeFeedback.Ripple = (color, borderless) => ({ type: "RippleAndroid", color, borderless });
TouchableNativeFeedback.SelectableBackground = (r) => ({ type: "ThemeAttrAndroid", attribute: "selectableItemBackground", rippleRadius: r });
TouchableNativeFeedback.SelectableBackgroundBorderless = (r) => ({ type: "ThemeAttrAndroid", attribute: "selectableItemBackgroundBorderless", rippleRadius: r });
TouchableNativeFeedback.canUseNativeForeground = () => false;

module.exports = { __esModule: true, default: TouchableNativeFeedback };
